import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import {
  Card,
  CardContent,
  // Grid,
  // LinearProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography
  // linearProgressClasses
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { adminTokens } from 'ui-component/admin/AdminPage';
import HotelBusinessAvatar from 'ui-component/hotel/HotelBusinessAvatar';

// assets
// import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';

// styles
// const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
//   height: 10,
//   borderRadius: 30,
//   [`&.${linearProgressClasses.colorPrimary}`]: {
//     backgroundColor: '#fff'
//   },
//   [`& .${linearProgressClasses.bar}`]: {
//     borderRadius: 5,
//     backgroundColor: theme.palette.primary.main
//   }
// }));

const CardStyle = styled(Card)(({ theme }) => ({
  background: 'transparent',
  border: '1px solid transparent',
  borderRadius: '6px',
  boxShadow: 'none',
  marginBottom: 0,
  overflow: 'hidden',
  position: 'relative'
}));

// ==============================|| PROGRESS BAR WITH LABEL ||============================== //

// function LinearProgressWithLabel({ value, ...others }) {
//   const theme = useTheme();

//   return (
//     <Grid container direction="column" spacing={1} sx={{ mt: 1.5 }}>
//       <Grid item>
//         <Grid container justifyContent="space-between">
//           <Grid item>
//             <Typography variant="h6" sx={{ color: theme.palette.primary[800] }}>
//               Progress
//             </Typography>
//           </Grid>
//           <Grid item>
//             <Typography variant="h6" color="inherit">{`${Math.round(value)}%`}</Typography>
//           </Grid>
//         </Grid>
//       </Grid>
//       <Grid item>
//         <BorderLinearProgress variant="determinate" value={value} {...others} />
//       </Grid>
//     </Grid>
//   );
// }

// LinearProgressWithLabel.propTypes = {
//   value: PropTypes.number
// };

// ==============================|| SIDEBAR MENU Card ||============================== //

const MenuCard = ({ collapsed = false, footer = false }) => {
  const theme = useTheme();
  const account = useSelector((state) => state.account);
  const navigate = useNavigate();

  return (
    <CardStyle
      sx={{
        mt: collapsed ? 1 : 0,
        mb: footer ? 0 : collapsed ? 1.5 : '22px',
        bgcolor: collapsed ? 'transparent' : adminTokens.surfaceAlt,
        borderColor: collapsed ? 'transparent' : adminTokens.border
      }}
    >
      <CardContent sx={{ p: collapsed ? 0.25 : 0.75, '&:last-child': { pb: collapsed ? 0.25 : 0.75 } }}>
        <List sx={{ p: 0, m: 0 }}>
          <ListItem
            alignItems="center"
            disableGutters
            sx={{
              p: 0,
              justifyContent: collapsed ? 'center' : 'flex-start'
            }}
          >
            <ListItemAvatar
              sx={{
                mt: 0,
                minWidth: collapsed ? 0 : 44,
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <HotelBusinessAvatar
                size={collapsed ? 38 : 32}
                sx={{
                  ...theme.typography.commonAvatar,
                  cursor: 'pointer',
                  marginRight: collapsed ? 0 : '6px'
                }}
                onClick={() => navigate('/panel/profile')}
              />
            </ListItemAvatar>
            {!collapsed && (
              <ListItemText
                sx={{ mt: 0, minWidth: 0 }}
                primary={
                  <Typography variant="subtitle1" noWrap sx={{ color: adminTokens.accent, fontWeight: 650, fontSize: 13.5, lineHeight: 1.25 }}>
                    {account.user?.username}
                  </Typography>
                }
                secondary={<Typography variant="caption" sx={{ color: adminTokens.muted, fontSize: 12, lineHeight: 1.25 }}>欢迎回来</Typography>}
              />
            )}
          </ListItem>
        </List>
      </CardContent>
    </CardStyle>
  );
};

MenuCard.propTypes = {
  collapsed: PropTypes.bool,
  footer: PropTypes.bool
};

export default MenuCard;
